import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { authStore } from 'src/stores/AuthStore';

interface Props {
  open: boolean;
  onClose: (action?: 'changePassword') => void;
}

export const UserProfileDialog: FC<Props> = ({ open, onClose }) => {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={() => onClose()} maxWidth="xs" fullWidth={true}>
      <DialogTitle> {t('userprofiledialog.headline')}</DialogTitle>
      <DialogContent>
        <div style={{ display: 'flex' }}>
          <div style={{ fontWeight: 'bold', paddingRight: 2 }}>{t('userprofiledialog.email')}: </div> <div>{authStore.username}</div>
        </div>
        <div style={{ display: 'flex' }}>
          <div style={{ fontWeight: 'bold', paddingRight: 2 }}>{t('userprofiledialog.phone')}: </div> <div>{authStore.phone}</div>
        </div>
        <div style={{ padding: '20px 0' }}>
          <Button color="secondary" variant="outlined" onClick={() => onClose('changePassword')} data-cy="change-password-button">
            {t('userprofiledialog.changepassword')}
          </Button>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()} autoFocus color="secondary">
          {t('userprofiledialog.ok')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
